import {
  CAR_PREVIEW_RECEIVE_PREVIEW_MODEL,
  CAR_PREVIEW_SET_IS_CAR_PREVIEW_OPEN,
} from '../constants';

const DEFAULT_STATE = {
  isOpen: false,
  previewModel: null,
};

export const carPreview = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CAR_PREVIEW_SET_IS_CAR_PREVIEW_OPEN:
    case CAR_PREVIEW_RECEIVE_PREVIEW_MODEL:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
